import { ComponentStyleConfig } from "@chakra-ui/react";

const FormLabelTheme: ComponentStyleConfig = {
  baseStyle: {
    color: "gray.600",
  },
  variants: {
    simple: {
      zIndex: 1,
      position: "absolute",
      pointerEvents: "none",
      pl: "16px",
      pr: "32px",
      my: 0,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      transformOrigin: "left top",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      alignItems: "center",
      color: "gray.400",
    },
    floating: {
      zIndex: 1,
      position: "absolute",
      pointerEvents: "none",
      mx: "16px",
      my: 0,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      transformOrigin: "left top",
      color: "gray.400",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      transform: "translate(0px, 13px) scale(1)",
      maxWidth: "calc(100% - 32px)",
      [".chakra-form-control:not([data-indeterminate]) &, " +
      "[data-editing] &," +
      ".chakra-form-control:focus-within &," +
      '.mb-input-content[data-input-type="date"]:focus-within &, ' +
      '.mb-input-content[data-input-type="text"]:focus-within &, ' +
      '.mb-input-content[data-input-type="textarea"]:focus-within &']: {
        transform: "translate(0px, 6px) scale(0.72)",
        color: "gray.600",
        maxWidth: "calc(133% - 32px - 48px)",
      },
      _disabled: {
        opacity: "unset",
      },
    },
  },
};

export default FormLabelTheme;
